import PropTypes from "prop-types";

const _Link = PropTypes.shape({
  title: PropTypes.string,
  url: PropTypes.string,
  target: PropTypes.string,
});

const _Sizes = PropTypes.shape({
  thumbnail: PropTypes.string,
  "thumbnail-width": PropTypes.number,
  "thumbnail-height": PropTypes.number,
  "16:9": PropTypes.string,
  "16:9-width": PropTypes.number,
  "16:9-height": PropTypes.number,
  "1:1": PropTypes.string,
  "1:1-width": PropTypes.number,
  "1:1-height": PropTypes.number,
  "3:2": PropTypes.string,
  "3:2-width": PropTypes.number,
  "3:2-height": PropTypes.number,
  hero: PropTypes.string,
  "hero-width": PropTypes.number,
  "hero-height": PropTypes.number,
  thumb: PropTypes.string,
  "thumb-width": PropTypes.number,
  "thumb-height": PropTypes.number,
});

const _Icon = PropTypes.shape({
  ID: PropTypes.number,
  id: PropTypes.number,
  title: PropTypes.string,
  filename: PropTypes.string,
  filesize: PropTypes.number,
  url: PropTypes.string,
  link: PropTypes.string,
  alt: PropTypes.string,
  author: PropTypes.string,
  description: PropTypes.string,
  caption: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.string,
  uploaded_to: PropTypes.number,
  date: PropTypes.string,
  modified: PropTypes.string,
  menu_order: PropTypes.number,
  mime_type: PropTypes.string,
  type: PropTypes.string,
  subtype: PropTypes.string,
  icon: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  sizes: _Sizes,
});

const _Padding = PropTypes.shape({
  display_padding: PropTypes.bool,
  padding_top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export const _Button_Component = PropTypes.shape({
  button_icon_position: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  button_icon: PropTypes.oneOfType([_Icon, PropTypes.any]),
  button_link: PropTypes.oneOfType([_Link, PropTypes.any]),
  button_order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  button_padding: _Padding,
  button_position: PropTypes.string,
  button_size: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  display_button_order: PropTypes.bool,
  display_button: PropTypes.bool,
});

const _Button = PropTypes.shape({
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  fullWidth: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
  ..._Button_Component,
});

export const ButtonPropTypes = PropTypes.oneOfType([_Button, PropTypes.any]);
